import { Modal } from 'baseui/modal'
import { Search } from 'baseui/icon'
import { SIZE } from 'baseui/button'
import { useTranslation } from 'react-i18next'
import usePceSearchV2 from './usePceSearchV2'
import PceSearchForm from './PceSearchForm'
import PceSearchResults from './PceSearchResults'
import { SearchModalHeader } from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/styled-components'
import useMeterSearchStyles from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/useMeterSearchStyles'

const PceSearchModal = () => {
  const { t } = useTranslation()
  const { isPulse, headerIconSize } = useMeterSearchStyles()
  const { isOpen, currentViewPage, modalOverrides, resetPceSearchData, updatePceConfigData } = usePceSearchV2()

  const handleClose = () => {
    updatePceConfigData({ isOpen: false })
    resetPceSearchData()
  }

  return (
    <Modal onClose={handleClose} isOpen={isOpen} size={SIZE.auto} overrides={modalOverrides}>
      <SearchModalHeader $pulse={isPulse}>
        <Search size={headerIconSize} />
        {t('subscriptionTools:pce_search.module_title')}
      </SearchModalHeader>

      {currentViewPage === 'search' && <PceSearchForm />}
      {currentViewPage === 'results' && <PceSearchResults />}
    </Modal>
  )
}

export default PceSearchModal
